import FunctionFormPage from "./function-form-page.jsx";
import "./style.less";

export default FunctionFormPage;
